<div class="category-exclusivity-control" [formGroup]="form" cdkDrag cdkDragBoundary=".cdk-overlay-container" cdkDragRootElement=".cdk-overlay-pane">
  <div cdkDragHandle class="category-exclusivity-header">
    <h1 mat-dialog-title class="dialog-header">{{dialogHeaderText}}</h1>
  </div>
  <div class="category-exclusivity-content">
    <div class="form-group">
      <mat-form-field>
        <mat-label>Podcast</mat-label>
        <mat-select formControlName="PodcastId" placeholder="Podcast">
          @for (podcast of administrationService.podcasts | filter:[{Disabled: false}]; track podcast.Id) {
            <mat-option [value]="podcast.Id">{{podcast.Name}}</mat-option>
          }
        </mat-select>
        @if (form.get('PodcastId').hasError('required')) {
          <mat-error>
            Podcast is <strong>required</strong>
          </mat-error>
        }
      </mat-form-field>
    </div>
    <div class="form-group">
      <kendo-floatinglabel text="Client">
        <kendo-combobox [data]="clients"
                        size="small"
                        rounded="medium"
                        [popupSettings]="comboBoxPopupSettings"
                        formControlName="ClientId"
                        fillMode="flat"
                        textField="Name"
                        valueField="Id"
                        [virtual]="virtual"
                        [filterable]="true"
                        (filterChange)="handleClientsFilter($event)"
                        valuePrimitive="true"
                        required>
        </kendo-combobox>
      </kendo-floatinglabel>
      @if (form.get('ClientId').hasError('required')) {
        <mat-error>
          Client is <strong>required</strong>
        </mat-error>
      }
    </div>
    <div class="form-group">
      <mat-form-field>
        <mat-label>Client Category</mat-label>
        <mat-select formControlName="ProductCategoryId" placeholder="Client Category">
          @for (productCategory of administrationService.productCategories | filter:[{Disabled: false}]; track productCategory.Id) {
            <mat-option [value]="productCategory.Id">{{productCategory.ProductCategoryName}}</mat-option>
          }
        </mat-select>
        @if (form.get('ProductCategoryId').hasError('required')) {
          <mat-error>
            Client Category is <strong>required</strong>
          </mat-error>
        }
      </mat-form-field>
    </div>
    <div class="form-group">
      <mat-form-field>
        <mat-label>Start Date</mat-label>
        <input matInput [matDatepicker]="sdatepicker" formControlName="StartDate" placeholder="Start Date" [min]="isNew ? commonService.today : null" autocomplete="off">
        <mat-datepicker-toggle matSuffix [for]="sdatepicker"></mat-datepicker-toggle>
        <mat-datepicker #sdatepicker startView="month"></mat-datepicker>
        @if (form.get('StartDate').hasError('required')) {
          <mat-error>
            Start Date is <strong>required</strong>
          </mat-error>
        }
      </mat-form-field>
    </div>
    <div class="form-group">
      <mat-form-field>
        <mat-label>End Date</mat-label>
        <input matInput [matDatepicker]="edatepicker" formControlName="EndDate" placeholder="End Date" [min]="form.get('StartDate').value || commonService.today" autocomplete="off">
        <mat-datepicker-toggle matSuffix [for]="edatepicker"></mat-datepicker-toggle>
        <mat-datepicker #edatepicker startView="month"></mat-datepicker>
        @if (form.get('EndDate').hasError('required')) {
          <mat-error>
            End Date is <strong>required</strong>
          </mat-error>
        }
      </mat-form-field>
    </div>
    <div class="form-group">
      <div class="checkbox-form-group">
        <mat-checkbox formControlName="Disabled">Disabled</mat-checkbox>
      </div>
    </div>
  </div>
  <div class="category-exclusivity-footer">
    <hr />
    <mat-dialog-actions>
      <div class="button-row">
        <button mat-button (click)="onCancelClick()">Close</button>
        <button mat-button color="primary" [disabled]="!form.valid || !form.dirty || saveInProgress" (click)="onSave()">Save</button>
      </div>
    </mat-dialog-actions>
  </div>
</div>
